// Попап для восстановления пароля

import basePopup from "./base-popup";
import ajaxForm from "../../components/ajax-form";
import labeledInput from "../../components/labeled-input";
import captcha from "../../captcha";

const template = /* html */`
    <transition name="fade">
        <base-popup
            id="reset-password-popup"
            show-logo
            v-cloak
            :isActive="isActive"
            v-show="isActive"
        >
            <template #header>
                <div class="popup__header-text">
                    <a href="#authorization_popup" class="js-show-popup">Войдите</a> или
                    <a href="#registration_popup" class="js-show-popup">зарегистрируйтесь</a>
                </div>
            </template>
            <ajax-form
                id="password-reset-form"
                action="/profile/password_reset/"
                submit-text="Получить инструкции"
                submit-class="popup__button"
                :shouldClearErrors="!isActive"
            >
                <template #default="props">
                    <input type="hidden" name="csrfmiddlewaretoken" :value="csrfToken">
                    <labeled-input
                        label="Почта"
                        input-type="email"
                        input-name="reset-email"
                        :error="props.errors.email?.[0]"
                        :value="email"
                        :is-focused="isActive"
                        @input="$emit('emailChanged', $event.target.value)"
                        small
                        required
                        helptext="отправим инструкции по восстановлению пароля"
                    />
                </template>
                <template
                    #captcha
                    v-if="captchaKey"
                >
                    <div
                        id="reset-password-popup-captcha"
                        class="js-captcha"
                        :data-sitekey="captchaKey"
                        :style="{minHeight: '105px'}"
                    >
                    </div>
                </template>
            </ajax-form>
        </base-popup>
    </transition>
`;

export default {
    props: {
        csrfToken: {
            type: String,
            required: true,
        },
        email: { type: String },
        captchaKey: { type: String },
        isActive: { type: Boolean },
    },
    template,
    data() {
        return { captchaId: null };
    },
    components: {
        basePopup,
        ajaxForm,
        labeledInput,
    },
    emits: ["emailChanged"],
    watch: {
        isActive(newVal) {
            if (!newVal) return;
            this.captchaId = captcha.init("#reset-password-popup-captcha");
        },
    },
    name: "ResetPasswordPopup",
};
